import { gql, useMutation } from "@apollo/client"
import { EVENT_TRIGGER_FIELDS } from "./useQueryTriggers"

const CREATE_EVENT_TRIGGER = gql`
  ${EVENT_TRIGGER_FIELDS}
  mutation CreateEventTrigger($input: EventTriggerInput!) {
    createEventTrigger(input: $input) {
      ...EventTriggerFields
    }
  }
`

const UPDATE_EVENT_TRIGGER = gql`
  ${EVENT_TRIGGER_FIELDS}
  mutation UpdateEventTrigger($id: ID!, $input: EventTriggerInput!) {
    eventTrigger(id: $id) {
      update(input: $input) {
        ...EventTriggerFields
      }
    }
  }
`

const useMutationCreateEventTrigger = (options) => useMutation(CREATE_EVENT_TRIGGER, options)

const useMutationUpdateEventTrigger = (options) => useMutation(UPDATE_EVENT_TRIGGER, options)

export { useMutationCreateEventTrigger, useMutationUpdateEventTrigger }
